"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.activateProject = exports.deactivateProject = void 0;
const core = __importStar(require("@actions/core"));
const github = __importStar(require("@actions/github"));
const build_body_1 = __importDefault(require("./build_body"));
async function deactivateProject(translates, rtd, branch, githubToken, rootProject) {
    const context = github.context;
    const octokit = github.getOctokit(githubToken);
    const disabled = await Promise.all(translates
        .map((p) => p.slug)
        .map((slug) => {
        return rtd.disableBuild(slug, branch);
    }))
        .then((allResult) => {
        return allResult.reduce((l, r) => l || r);
    })
        .catch((e) => {
        octokit.rest.issues.createComment({
            owner: context.issue.owner,
            repo: context.issue.repo,
            issue_number: context.issue.number,
            body: e.message,
        });
        throw e;
    });
    if (disabled) {
        core.info(`Successfully disabled RTD build for ${branch} branch in ${rootProject}.`);
    }
    else {
        core.info(`RTD build for ${branch} branch in ${rootProject} is already disabled, so no reaction needed.`);
    }
}
exports.deactivateProject = deactivateProject;
async function activateProject(translates, rtd, branch, githubToken, rootProject) {
    const context = github.context;
    const octokit = github.getOctokit(githubToken);
    const enabled = await Promise.all(translates
        .map((p) => p.slug)
        .map((slug) => {
        return rtd.enableBuild(slug, branch);
    }))
        .then((allResult) => {
        return allResult.reduce((l, r) => l || r);
    })
        .catch((e) => {
        octokit.rest.issues.createComment({
            owner: context.issue.owner,
            repo: context.issue.repo,
            issue_number: context.issue.number,
            body: e.message,
        });
        throw e;
    });
    if (enabled) {
        core.info(`Reporting document URL to GitHub PR page of ${branch} branch in ${rootProject}.`);
        const body = (0, build_body_1.default)(context.payload.pull_request?.body || "", translates, branch);
        octokit.rest.issues.update({
            owner: context.issue.owner,
            repo: context.issue.repo,
            issue_number: context.issue.number,
            body,
        });
    }
    else {
        core.info(`RTD build for ${branch} branch in ${rootProject} is already activated, so no reaction needed.`);
    }
}
exports.activateProject = activateProject;
